"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpanderContent = exports.IconWrapper = exports.TextButtonLabel = exports.ExpanderHead = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var storm_ui_1 = require("@amzn/storm-ui");
exports.ExpanderHead = (0, styled_components_1.default)(storm_ui_1.TextButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: left;\n  align-items: stretch;\n  text-align: initial;\n  color: ", ";\n  font-size: ", ";\n  :hover {\n    text-decoration: none;\n    color: ", ";\n  }\n  width: 100%;\n"], ["\n  display: flex;\n  justify-content: left;\n  align-items: stretch;\n  text-align: initial;\n  color: ", ";\n  font-size: ", ";\n  :hover {\n    text-decoration: none;\n    color: ", ";\n  }\n  width: 100%;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.squidInk;
}, function (_a) {
    var theme = _a.theme;
    return theme.typography.size.medium;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.squidInk;
});
exports.TextButtonLabel = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  flex: 1 1 auto;\n"], ["\n  flex: 1 1 auto;\n"])));
exports.IconWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  color: ", ";\n  width: ", ";\n  padding-inline-end: ", ";\n  flex: 0 0 auto;\n"], ["\n  display: flex;\n  color: ", ";\n  width: ", ";\n  padding-inline-end: ", ";\n  flex: 0 0 auto;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.black;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.base;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.mini;
});
exports.ExpanderContent = styled_components_1.default.section(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: ", ";\n  padding-top: ", ";\n"], ["\n  display: ", ";\n  padding-top: ", ";\n"])), function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? 'block' : 'none');
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.large;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
